import { useCallback, useEffect, useState } from 'react'
import { authAPI } from '../services/api'

/**
 * useTwoFactorStatus — the single fetch behind every 2FA statement in the app.
 *
 * ★★ It keeps `error` SEPARATE from an empty status on purpose. The screen this
 *    replaces swallowed the failure into a console.error and rendered the same
 *    thing it renders for "you have no 2FA". See utils/securityPosture.js.
 */
export default function useTwoFactorStatus() {
  const [status, setStatus] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await authAPI.get2faStatus()
      setStatus(data)
    } catch (err) {
      console.error('[Security] 2FA status fetch failed:', err)
      setStatus(null)
      setError(err || new Error('failed'))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  return { status, error, loading, reload: load }
}
